/**
 * FormularioPreCadastro - Componente Principal
 * Orquestra o fluxo do formulário com navegação e branching logic
 */

import React, { useMemo, useState } from 'react';
import { FormProvider, useFormContext } from './context';
import { ProgressBar } from './components';
import { useFormStep } from './hooks';
import STEPS from './steps';

/**
 * Componente Renderizador de Steps
 * Renderiza o step atual com base no índice
 */
const StepRenderer: React.FC = () => {
  const { data, currentStepIndex, error, isLoading, goToNextStep, goToPreviousStep } =
    useFormContext();
  const { progress } = useFormStep();

  const currentStep = STEPS[currentStepIndex];

  if (!currentStep) {
    return <div className="step-error">Step não encontrado</div>;
  }

  const Component = currentStep.component;

  const handleNext = (newData: any, nextStepId?: string) => {
    // Atualizar dados no contexto
    Object.keys(newData).forEach((key) => {
      const formKey = key as any;
      data[formKey] = newData[key];
    });
  
    // Se houver nextStepId (branching), ir para lá
    if (nextStepId) {
      const nextIndex = STEPS.findIndex((s) => s.id === nextStepId);
      if (nextIndex >= 0) {
        goToNextStep(nextStepId);
      }
    } else {
      // Caso contrário, próximo step normal
      goToNextStep();
    }
  };

  return (
    <div className="step-renderer">
      {/* <ProgressBar
        progress={progress}
        currentStep={currentStepIndex}
        totalSteps={STEPS.length}
        className="step-progress"
      /> */}

      {error && <div className="error-banner">{error}</div>}

      <Component
        data={data}
        onNext={handleNext}
        onPrevious={goToPreviousStep}
        isLoading={isLoading}
      />
    </div>
  );
};

/**
 * Componente Principal do Formulário
 */
const FormularioPreCadastro: React.FC<{ indicatedCode?: string }> = ({ indicatedCode }) => {
  return (
    <FormProvider indicatedCode={indicatedCode}>
      <div className="formulario-pre-cadastro">
        <div className="formulario-container">
          <div className="formulario-header">
            <div className="flex flex-col items-center">
              <div className='flex items-center p-2 rounded-lg bg-white mb-2'>
                <img
                  src="/v2/logos/logo-mini.png"
                  alt="Logo X do Infinito"
                  className="w-8 h-8 object-contain mr-2"
                />
                <h1 className='text-lg font-bold text-primary'>X do Infinito</h1>
              </div>
            </div>
            <p className="formulario-subtitle">Formulário de Seleção</p>
          </div>

          <StepRenderer />

          {/* <div className="formulario-footer">
            <p className="footer-text">
              Suas informações serão mantidas em sigilo e seguem nossa política de privacidade.
            </p>
          </div> */}
        </div>
      </div>
    </FormProvider>
  );
};

export default FormularioPreCadastro;
